import React from 'react';
import { Button, InfoCard } from '../../components';
import DynamicChart from '../../components/Chart/DynamicChart';
import Terminal from '../../components/Terminal/Terminal';
import BottomNav from '../../components/BottomNav/Boomnav';
import { COLORS } from '../../constants/colors';
import './BotPage.css';
import { useBot } from '../../context/BotContext';

const BotPage = ({ balance, onBalanceUpdate, onNavigate }) => {
  const {
    isRunning, status, statusColor, statusPulse, timeLeft, logs, trades, chartData,
    startCycle, stopCycle, finishCycle
  } = useBot();
  const [active, setActive] = React.useState('bot');
  
  const handleNavChange = (id) => {
    setActive(id);
    if (onNavigate) onNavigate(id);
  };

  const handleStartCycle = () => {
    startCycle(balance, onBalanceUpdate);
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  // Saldo em tempo real: último valor do gráfico se rodando, senão o balance inicial
  let realTimeBalance = isRunning && chartData.length > 0
    ? chartData[chartData.length - 1]
    : balance;
  // Garantir que nunca seja NaN ou indefinido
  if (realTimeBalance === undefined || isNaN(Number(realTimeBalance))) {
    realTimeBalance = balance;
  }

  return (
    <div className="bot-page" style={{ background: '#1A1D24', minHeight: '100vh', paddingBottom: 90 }}>
      {/* Header com Status e Saldo */}
      <div className="bot-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
        <div>
          <div className="header-label" style={{ fontSize: 10, fontWeight: 700, color: COLORS.textMuted, marginBottom: 4 }}>STATUS</div>
          <div className="status-display" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div
              className="status-dot"
              style={{
                backgroundColor: statusColor,
                animation: statusPulse ? 'pulseWarning 1s infinite' : 'none',
                width: 8, height: 8, borderRadius: '50%'
              }}
            />
            <span className="status-text" style={{ fontSize: 13, fontWeight: 700, color: '#00C689' }}>{status}</span>
            {isRunning && (
              <button className="btn-pause-inline" style={{ marginLeft: 12, background: 'none', border: 'none', color: '#00c089', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }} onClick={() => stopCycle()}>
                <span>⏸</span> Pausar
              </button>
            )}
          </div>
        </div>
        <div className="balance-section" style={{ textAlign: 'right' }}>
          <div className="header-label" style={{ fontSize: 10, fontWeight: 700, color: COLORS.textMuted, marginBottom: 4 }}>SALDO ATUAL</div>
          <div className="text-mono balance-value" style={{ fontSize: 20, fontWeight: 700, color: '#00C689' }}>$ {Number(realTimeBalance).toFixed(2)}</div>
        </div>
      </div>

      {/* Info Card */}
      <div style={{ background: '#47526B', borderRadius: 12, border: '1.5px solid #00C689', padding: 16, marginBottom: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, color: '#00C689', fontSize: 16, marginBottom: 6 }}>
          Central de Operações
        </div>
        <div style={{ color: '#c0d0e6', fontSize: 14 }}>O robô Prisma executa ciclos operacionais simulados, identificando oportunidades.</div>
      </div>

      {/* Timer */}
      {isRunning && (
        <div style={{ textAlign: 'center', background: COLORS.secondary, color: '#fff', padding: 8, borderRadius: 8, marginBottom: 16, fontFamily: 'monospace', fontSize: 12 }}>
          TEMPO RESTANTE: <span>{formatTime(timeLeft)}</span>
        </div>
      )}

      {/* Gráfico Dinâmico */}
      <DynamicChart data={Array.isArray(chartData) ? chartData : []} />

      {/* Terminal */}
      <div className="terminal" style={{ background: '#232b36', color: '#fff', borderRadius: 8, padding: 12, minHeight: 60, fontFamily: 'monospace', fontSize: 13, marginBottom: 18 }}>
        {logs.map((log, i) => (
          <div key={i} className="log-entry">{log.time} {log.message}</div>
        ))}
      </div>

      {/* Histórico de Trades */}
      <h3 className="section-title" style={{ fontSize: 11, fontWeight: 700, color: COLORS.textMuted, marginBottom: 8, textTransform: 'uppercase' }}>Histórico Recente</h3>
      <div className="timeline-container">
        {trades.length === 0 ? (
          <div className="empty-trades" style={{ color: '#c0d0e6', textAlign: 'center', padding: 12 }}>
            <p>Nenhuma operação realizada ainda</p>
          </div>
        ) : (
          trades.map((trade, index) => (
            <div key={index} className="timeline-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#47526B', borderRadius: 8, border: '1px solid #00C689', padding: '8px 12px', marginBottom: 8 }}>
              <div className="timeline-left" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div className={`timeline-dot ${trade.type}`} style={{ width: 10, height: 10, borderRadius: '50%', background: trade.type === 'win' ? '#00C689' : '#EF4444' }} />
                <div className="timeline-asset" style={{ color: '#fff', fontWeight: 700 }}>{trade.asset}</div>
              </div>
              <div className="timeline-right" style={{ textAlign: 'right' }}>
                <div className={`timeline-result text-mono`} style={{ color: trade.type === 'win' ? '#00C689' : '#EF4444', fontWeight: 700 }}>{trade.value}</div>
                <div className="timeline-time" style={{ color: '#c0d0e6', fontSize: 12 }}>{trade.time}</div>
              </div>
            </div>
          ))
        )}
      </div>

      {!isRunning && (
        <div className="bot-action-container" style={{ display: 'flex', justifyContent: 'center', margin: '32px 0 24px 0' }}>
          <Button onClick={handleStartCycle} style={{ boxShadow: '0 10px 30px rgba(0, 198, 137, 0.3)', minWidth: '220px' }}>
            INICIAR CICLO AUTOMATIZADO
          </Button>
        </div>
      )}
      <div style={{ height: '80px' }} />
      <BottomNav active={active} onChange={handleNavChange} />
    </div>
  );
};

export default BotPage;